<template lang="pug">
  span.mdi(:class="iconClass")
</template>

<script>
export default {
  name: 'AppIcon',
  props: {
    icon: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      required: true,
    },
  },
  computed: {
    iconClass() {
      const iconKey = `mdi-${this.icon}`;
      const sizeKey = `mdi-${this.size}px`;

      return { [iconKey]: this.icon, [sizeKey]: this.size };
    },
  },
};
</script>

<style lang="stylus" scoped>
.mdi
  height 100%
  width 100%
</style>
